module.exports = __webpack_public_path__ + "media/images/warning_desktop_graphic-1856d055909ac24b17542265cfbc1fbd.svg";